const prefix = (type) => `eureka/fields/${type}`;

export const LOAD_START = prefix('LOAD_START');
export const LOAD_SUCCESS = prefix('LOAD_SUCCESS');
export const LOAD_FAILED = prefix('LOAD_FAILED');

export const CLEAR_STATE = prefix('CLEAR_STATE');
